import * as React from 'react'


import { AboutUsComp, AboutUsContent, ContactDiv, Photo, PhotoDiv, TextBody, TextContent, TextTitle } from './styles';
import { Formulario } from './formulario';

import PhotoContact from '../../../../../assets/images/landingPage/photo/rodrigo.jpeg';

interface INavBar {
    
}

const Orcamento: React.FC<INavBar> = () => {

    return (
        <AboutUsComp id='contlp'>
            <AboutUsContent>
                <TextContent>
                    <ContactDiv>
                        <PhotoDiv>
                            <Photo src={PhotoContact}/>
                        </PhotoDiv>
                        <TextTitle>
                            <h1>Rodrigo Vasconcelos</h1>
                            <h2>Gerente Comercial do BHBUS Mídia</h2>
                            <h2>31 98302-4595</h2>
                            {/* <a
                                href="https://api.whatsapp.com/send/?phone=31983024595&text&type=phone_number&app_absent=0"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ display: 'block' }}
                            >
                                <h2 className='contato'>Entre em contato</h2>
                            </a> */}
                        </TextTitle>
                    </ContactDiv>
                    <TextBody>
                        <Formulario />
                    </TextBody>
                </TextContent>
            </AboutUsContent>
        </AboutUsComp>
    );
}

export { Orcamento }